import { ValidationError } from 'WebmcpCore/errors';
import type { WebMcpToolDefinition } from 'WebmcpCore/types';
import type { z } from 'zod';

const NAME_PATTERN = /^[a-z][a-zA-Z0-9]*(\.[a-z][a-zA-Z0-9]*){1,3}$/;

export function defineTool<TInput extends z.ZodTypeAny, TOutput extends z.ZodTypeAny = z.ZodTypeAny>(spec: WebMcpToolDefinition<TInput, TOutput>): WebMcpToolDefinition<TInput, TOutput> {
  if (!NAME_PATTERN.test(spec.name)) {
    throw new ValidationError(`Tool name '${spec.name}' must match {surface}.{resource}.{action} pattern (lowercase alphanumeric, 2-4 segments)`);
  }
  if ((spec.tier === 'user-scoped' || spec.tier === 'admin') && !spec.previewIntent) {
    throw new ValidationError(`Tool '${spec.name}' is tier=${spec.tier} — previewIntent is required for write-tier tools`);
  }
  return spec;
}
